"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.timelineModule = void 0;
var angular_1 = __importDefault(require("angular"));
/**
 * Interactive timeline directive (zoom + pan) for extended day timeline view.
 * Usage:
 *   <aud-timeline bands="dailyTally.timeline.bands"
 *                 ticks="dailyTally.timeline.ticks"
 *                 start-ms="dailyTally.timeline.startMs"
 *                 end-ms="dailyTally.timeline.endMs"
 *                 width-px="dailyTally.timeline.widthPx"
 *                 px-per-hour="dailyTally.timeline.pxPerHour"
 *                 highlight-left="dailyTally.timeline.highlightLeftPx"
 *                 highlight-width="dailyTally.timeline.highlightWidthPx"
 *                 on-span-click="showTimelinePopup(sp, $event)"></aud-timeline>
 */
exports.timelineModule = angular_1.default.module('aud.timeline', [])
    .directive('audTimeline', ['$document', '$window', function ($document, $window) {
        return {
            restrict: 'E',
            scope: {
                bands: '=bands',
                ticks: '=ticks',
                startMs: '=startMs',
                endMs: '=endMs',
                widthPx: '=widthPx',
                pxPerHour: '=pxPerHour',
                highlightLeft: '=highlightLeft',
                highlightWidth: '=highlightWidth',
                onSpanClick: '&',
                onReady: '&?'
            },
            template: "\n      <div class=\"aud-timeline-wrapper\" ng-class=\"{'is-panning': vm.isPanning}\" tabindex=\"0\">\n        <div class=\"aud-timeline-inner\" ng-style=\"{ width: vm.state.width + 'px' }\">\n          <div class=\"aud-timeline-highlight\" ng-style=\"{ left: highlightLeft + 'px', width: highlightWidth + 'px' }\"></div>\n          <div class=\"aud-timeline-window\" ng-if=\"vm.window\" ng-style=\"vm.windowStyle()\"></div>\n          <div class=\"aud-timeline-tick\" ng-repeat=\"t in ticks\" ng-style=\"{ left: t.px * vm.state.zoom + vm.state.offset + 'px' }\">\n            <span>{{t.label}}</span>\n          </div>\n          <div class=\"aud-timeline-band\" ng-repeat=\"band in bands track by $index\" ng-style=\"{ top: (24 + ($index* (vm.laneHeight*vm.previewLaneCount + 14))) + 'px' }\">\n            <div class=\"aud-timeline-band-label\">\n              {{band.name}} <span class=\"label label-default\">{{band.lanes.length}}</span>\n              <a href ng-click=\"vm.toggleBand(band)\" class=\"small\">{{band._collapsed ? 'expand' : 'collapse'}}</a>\n            </div>\n            <div class=\"aud-timeline-lane\" ng-repeat=\"lane in vm.getVisibleLanes(band) track by $index\" ng-style=\"{ height: vm.laneHeight + 'px' }\">\n              <div class=\"aud-timeline-span timeline-span\" ng-repeat=\"sp in lane track by sp.id\"\n                   ng-class=\"sp.cls\"\n                   title=\"{{sp.title}}\"\n                   ng-style=\"vm.spanStyle(sp)\"\n                   ng-click=\"vm.clickSpan(sp, $event)\">\n                  <span class=\"small\">{{sp.topic || sp.id}}</span>\n              </div>\n            </div>\n            <div class=\"text-muted small\" ng-if=\"band._collapsed && band.overflowCount>0\" style=\"margin-left:6px;\">+ {{band.overflowCount}} more lane(s) hidden</div>\n          </div>\n        </div>\n      </div>\n    ",
            link: function (scope, elem) {
                // Ensure view-model container exists
                scope.vm = scope.vm || {};
                scope.bands = scope.bands || [];
                scope.ticks = scope.ticks || [];
                var MIN_ZOOM = 0.25; // 25% zoomed out
                var MAX_ZOOM = 8; // 8x zoom in
                var state = scope.vm.state = { zoom: 1, offset: 0, width: scope.widthPx };
                var wrapperEl = elem[0].querySelector('.aud-timeline-wrapper');
                if (!wrapperEl)
                    return; // safety: template not rendered
                // --- Helpers ---
                function clamp(v, lo, hi) { return v < lo ? lo : (v > hi ? hi : v); }
                function rebuildWidth() {
                    // Maintain width scaling relative to base widthPx * zoom so panning area grows when zooming in.
                    state.width = Math.round(scope.widthPx * state.zoom);
                }
                function ensureOffsetBounds() {
                    var viewW = (wrapperEl ? wrapperEl.clientWidth : 800) || 800;
                    var maxOffset = Math.max(0, viewW - state.width);
                    // If content wider than viewport offset min is negative.
                    var minOffset = Math.min(0, viewW - state.width);
                    if (state.offset > 0)
                        state.offset = 0; // prevent scrolling beyond left
                    if (state.offset < minOffset)
                        state.offset = minOffset; // clamp right
                }
                function pointToTimelineX(clientX) {
                    if (!wrapperEl)
                        return 0; // fallback
                    var rect = wrapperEl.getBoundingClientRect();
                    return (clientX - rect.left - state.offset) / state.zoom; // base coordinate in original px space
                }
                function applyZoom(newZoom, centerPxBase) {
                    var oldZoom = state.zoom;
                    state.zoom = clamp(newZoom, MIN_ZOOM, MAX_ZOOM);
                    rebuildWidth();
                    // Maintain the base coordinate under cursor/pinch center
                    var before = centerPxBase * oldZoom + state.offset;
                    var after = centerPxBase * state.zoom;
                    state.offset = before - after;
                    ensureOffsetBounds();
                    scope.$evalAsync();
                }
                // --- Public span style (applies zoom + offset) ---
                scope.vm.spanStyle = function (sp) {
                    var left = sp.leftPx * state.zoom + state.offset;
                    var width = Math.max(1, sp.widthPx * state.zoom);
                    return { left: left + 'px', width: width + 'px', height: (scope.vm.laneHeight - 2) + 'px' };
                };
                // --- Band helpers ---
                scope.vm.previewLaneCount = 3;
                scope.vm.laneHeight = 22;
                scope.vm.toggleBand = function (band) { band._collapsed = !band._collapsed; };
                scope.vm.getVisibleLanes = function (band) { return band._collapsed ? band.lanes.slice(0, band.maxPreviewLanes || scope.vm.previewLaneCount) : band.lanes; };
                scope.vm.clickSpan = function (sp, $event) { scope.onSpanClick({ sp: sp, $event: $event }); };
                scope.vm.windowStyle = function () {
                    if (!scope.vm.window)
                        return {};
                    var left = scope.vm.window.leftBase * state.zoom + state.offset;
                    var width = scope.vm.window.widthBase * state.zoom;
                    return { left: left + 'px', width: width + 'px' };
                };
                // --- Wheel zoom (Ctrl/Cmd + wheel for zoom; plain wheel = horizontal scroll) ---
                wrapperEl.addEventListener('wheel', function (ev) {
                    var e = ev;
                    if (e.ctrlKey || e.metaKey) {
                        e.preventDefault();
                        var baseX = pointToTimelineX(e.clientX);
                        var delta = e.deltaY > 0 ? -0.2 : 0.2;
                        applyZoom(state.zoom * (1 + delta), baseX);
                    }
                    else if (e.shiftKey) {
                        e.preventDefault();
                        state.offset -= e.deltaY;
                        ensureOffsetBounds();
                        scope.$evalAsync();
                    }
                }, { passive: false });
                // --- Basic horizontal wheel scroll (without modifiers) ---
                wrapperEl.addEventListener('wheel', function (ev) {
                    var e = ev;
                    if (!(e.ctrlKey || e.metaKey || e.shiftKey)) {
                        state.offset -= e.deltaY;
                        ensureOffsetBounds();
                        scope.$evalAsync();
                    }
                }, { passive: true });
                // --- Pointer drag panning (mouse + touch) ---
                var panActive = false;
                var lastX = 0;
                function pointerDown(ev) {
                    if (ev.button !== 0)
                        return; // left button only
                    panActive = true;
                    lastX = ev.clientX;
                    scope.vm.isPanning = true;
                    ev.target.setPointerCapture(ev.pointerId);
                }
                function pointerMove(ev) {
                    if (!panActive)
                        return;
                    var dx = ev.clientX - lastX;
                    lastX = ev.clientX;
                    state.offset += dx;
                    ensureOffsetBounds();
                    scope.$evalAsync();
                }
                function pointerUp(ev) { if (!panActive)
                    return; panActive = false; scope.vm.isPanning = false; }
                wrapperEl.addEventListener('pointerdown', pointerDown);
                wrapperEl.addEventListener('pointermove', pointerMove);
                wrapperEl.addEventListener('pointerup', pointerUp);
                wrapperEl.addEventListener('pointerleave', pointerUp);
                // --- Touch pinch zoom ---
                var pinch = { active: false, startDist: 0, startZoom: 1, centerBase: 0 };
                wrapperEl.addEventListener('touchstart', function (e) {
                    var t = e;
                    if (t.touches.length === 2) {
                        e.preventDefault(); // prevent default touch behavior
                        pinch.active = true;
                        var t1 = t.touches[0];
                        var t2 = t.touches[1];
                        pinch.startDist = Math.hypot(t2.clientX - t1.clientX, t2.clientY - t1.clientY);
                        pinch.startZoom = state.zoom;
                        var centerClientX = (t1.clientX + t2.clientX) / 2;
                        pinch.centerBase = pointToTimelineX(centerClientX);
                    }
                }, { passive: false });
                wrapperEl.addEventListener('touchmove', function (e) {
                    var t = e;
                    if (pinch.active && t.touches.length === 2) {
                        e.preventDefault();
                        var t1 = t.touches[0];
                        var t2 = t.touches[1];
                        var dist = Math.hypot(t2.clientX - t1.clientX, t2.clientY - t1.clientY);
                        var scale = dist / (pinch.startDist || 1);
                        applyZoom(pinch.startZoom * scale, pinch.centerBase);
                    }
                }, { passive: false });
                wrapperEl.addEventListener('touchend', function (e) {
                    var t = e;
                    if (t.touches.length === 0) {
                        pinch.active = false;
                    }
                }, { passive: true });
                scope.$watchGroup(['widthPx'], function () { rebuildWidth(); ensureOffsetBounds(); });
                scope.$watch('bands', function (v) { if (!Array.isArray(v))
                    scope.bands = []; });
                scope.$watch('ticks', function (v) { if (!Array.isArray(v))
                    scope.ticks = []; });
                // Initial size
                rebuildWidth();
                // --- External API (fit helpers) ---
                function applyZoomOffset(zoom, offset) {
                    state.zoom = zoom;
                    state.offset = offset;
                    rebuildWidth();
                    ensureOffsetBounds();
                    scope.$evalAsync();
                }
                function baseScale() { var totalMs = (scope.endMs - scope.startMs); return totalMs > 0 ? (scope.widthPx / totalMs) : 0; }
                function windowSet(startMs, endMs) {
                    var scale = baseScale();
                    if (scale <= 0) {
                        scope.vm.window = null;
                        return;
                    }
                    var leftBase = (startMs - scope.startMs) * scale;
                    var widthBase = Math.max(1, (endMs - startMs) * scale);
                    scope.vm.window = { leftBase: leftBase, widthBase: widthBase };
                }
                var api = {
                    fitSpan: function (startMs, endMs) {
                        if (!(scope.endMs > scope.startMs))
                            return;
                        var viewW = wrapperEl ? wrapperEl.clientWidth : 800;
                        if (viewW <= 0)
                            return;
                        var totalMs = scope.endMs - scope.startMs;
                        var scale = scope.widthPx / totalMs;
                        var clampStart = Math.max(scope.startMs, startMs);
                        var clampEnd = Math.min(scope.endMs, endMs);
                        if (clampEnd <= clampStart)
                            return;
                        var spanMs = clampEnd - clampStart;
                        var neededBase = spanMs * scale;
                        if (neededBase <= 0)
                            return;
                        var zoom = Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, viewW / neededBase));
                        var spanLeftBase = (clampStart - scope.startMs) * scale;
                        var offset = -spanLeftBase * zoom;
                        applyZoomOffset(zoom, offset);
                        windowSet(startMs, endMs);
                    },
                    fitAll: function () {
                        this.fitSpan(scope.startMs, scope.endMs);
                    },
                    fitCurrent8h: function (nowMs) {
                        var now = nowMs || Date.now();
                        var eight = 8 * 3600 * 1000;
                        var start = Math.max(scope.startMs, Math.min(now - 4 * 3600 * 1000, scope.endMs - eight));
                        var end = Math.min(scope.endMs, start + eight);
                        this.fitSpan(start, end);
                    },
                    getState: function () { return { zoom: state.zoom, offset: state.offset }; },
                    setState: function (z, o) { applyZoomOffset(z, o); }
                };
                try {
                    if (scope.onReady)
                        scope.onReady({ api: api });
                }
                catch (_a) { }
            }
        };
    }]);
exports.default = exports.timelineModule.name;
